<template>
  <footer id="footer">
    <div class="container">
      <div class="row">
        <div class="footer-copyright col-12 col-sm-4 text-center text-sm-left">
          &copy; The Salvation Army 2019
        </div>
        <div class="footer-links col-12 col-sm-8 text-center text-sm-right">
          <router-link :to="aboutURL" class="about-contact-us mr-3">About / Contact Us</router-link>
          <router-link :to="termsOfServiceURL" class="terms-of-service">Terms of Service</router-link>
        </div>
      </div>
      <div class="row footer-image">
        <img class="footer-image--greenery" src="../assets/img/global/footer-greenery.png" />
      </div>
    </div>
  </footer>
</template>

<script>
import routeNames from '../util/routeNames';

export default {
  name: 'Footer',
  data() {
    return {
      aboutURL: routeNames.ABOUT.PATH,
      termsOfServiceURL: routeNames.TERMSOFSERVICE.PATH
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/vendor/_bootstrap-setup";
@import "../styles/environment/_variables";

footer#footer {
  font-size: $sa-footer-font-size;
  min-height: 100px;
  position: absolute;
  bottom: 0;
  width: 100%;

  .footer-copyright {
    @include media-breakpoint-down(sm) {
      margin-bottom: 20px;
    }
  }

  .footer-image{
    height: 100px;
    overflow: visible;
    position: relative;

    .footer-image--greenery {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      z-index: -1;
    }
  }
}
</style>
